import { Divider, Stack } from '@mui/material';
import { IAddresses } from 'API/personalDetails';
import { ADDRESS_TYPES, DICTIONARY } from 'Enum';
import { HomeAddress } from './HomeAddress';
import { useEffect, useState } from 'react';
import { PostOffice } from './PostOffice';
import { Dictionary } from 'Dictionary';
import { NavigateTo } from '../NavigateTo';
import { useIsDesktop } from 'Hooks';

export interface IILHomeAddress {
  townId: number | null;
  town: string | null | undefined;
  street: string | null;
  zipCode: number | null;
}
export interface IILHomeAddressWithoutTownId
  extends Omit<IILHomeAddress, 'townId'> {}

export interface IAbroadAddress {
  countryId: number | null;
  abroadTown: string;
}

export interface IPostOfficeAddress {
  postOffice: string | null;
  zipCode: number | null;
}

interface IAddressInformation {
  addresses: IAddresses[];
}

export const AddressInformation = ({ addresses }: IAddressInformation) => {
  const [userAddresses, setUserAddresses] = useState<{
    home: IILHomeAddress | null;
    abroad: IAbroadAddress | null;
    postOffice: IPostOfficeAddress | null;
  }>({
    home: null,
    abroad: null,
    postOffice: null,
  });

  const isDesktop = useIsDesktop();

  useEffect(() => {
    const tempUserAddresses: any = {
      home: null,
      abroad: null,
      postOffice: null,
    };
    for (let i = 0; i < addresses.length; i++) {
      if (addresses[i].addressTypeId === ADDRESS_TYPES.home)
        tempUserAddresses.home = addresses[i];
      if (addresses[i].addressTypeId === ADDRESS_TYPES.abroad)
        tempUserAddresses.abroad = {
          countryId: addresses[i].countryId,
          abroadTown: addresses[i].abroadTown,
        };
      if (addresses[i].addressTypeId === ADDRESS_TYPES.poBox)
        tempUserAddresses.postOffice = {
          postOffice: addresses[i].postOffice,
          zipCode: addresses[i].zipCode,
        };
    }
    setUserAddresses(tempUserAddresses);
  }, [addresses]);

  return (
    <Stack gap={isDesktop ? '24px' : '20px'}>
      <HomeAddress address={userAddresses.home} abroad={userAddresses.abroad} />
      <Divider
        aria-hidden={'true'}
        orientation={'horizontal'}
        sx={{ borderColor: 'primary.shade_100' }}
      />
      <PostOffice postOfficeAddress={userAddresses.postOffice} />
      <NavigateTo
        href='/requests/update-personal-details/8/18'
        label={Dictionary[DICTIONARY.PersonalDetails].links.updateAddress}
      />
    </Stack>
  );
};
